import { SET_CURRENCY } from '../constants/actionTypes';
import * as api from '../api';

export const setCurrency = (currency) => async (dispatch) => {
    try {
        dispatch({ type: SET_CURRENCY, payload: currency});
    } catch (error) {
        console.log(error.message)
    }
}